//@flow

import {
  createBannerGroupApi,
  getBannerGroupApi,
  endpoints,
  deleteBannerGroupApi,
  deleteBannerApi,
  editBannerGroupApi,
} from '../api';

import type {CreateBannerGroupRequest, UpdateBannerGroupRequest} from '../api';
import type {BannerGroup} from '../../../entities';
import {buildRoute} from '../../../http';

export function createBannerGroupService(
  data: CreateBannerGroupRequest
): Promise<BannerGroup> {
  return createBannerGroupApi(data).toPromise();
}

export function getBannerService(): Promise<BannerGroup[]> {
  return getBannerGroupApi().toPromise();
}

export function deleteBannerService(bannerId: string): Promise<void> {
  const route = buildRoute(endpoints.DELETE_BANNER, [bannerId]);

  return deleteBannerApi({route}).toPromise();
}

export function deleteBannerGroupService(BannerGroupId: string): Promise<void> {
  const route = buildRoute(endpoints.DELETE_BANNER_GROUP, [BannerGroupId]);

  return deleteBannerGroupApi({route}).toPromise();
}

export function editBannerGroupService(
  bannerGroupId: string,
  data: UpdateBannerGroupRequest
): Promise<BannerGroup> {
  const route = buildRoute(endpoints.EDIT_BANNER_GROUP, [bannerGroupId]);

  return editBannerGroupApi(data, {route}).toPromise();
}
